import { SingleInputConnectIntegrationFormDrawerContent } from '@modules/integrationsV2/components/AddIntegrationFormDrawerContent/SingleInputConnectIntegrationFormDrawerContent';
import { GetAddIntegrationFormDrawerContentProps } from '@modules/integrationsV2/utils/getAddIntegrationFormDrawerContent';
import { useState } from 'react';

export const ChorusFormDrawerContent = ({
  integrationType,
  integrationChannel,
  onDrawerClose,
  integrationID,
}: GetAddIntegrationFormDrawerContentProps) => {
  const [apiKey, setApiKey] = useState('');

  return (
    <SingleInputConnectIntegrationFormDrawerContent
      integrationID={integrationID}
      inputFieldData={apiKey}
      setInputFieldData={setApiKey}
      integrationChannel={integrationChannel}
      integrationType={integrationType}
      integrationData={{
        chorus: {
          apiKey,
        },
      }}
      updateAuthData={{
        chorus: {
          apiKey,
        },
      }}
      textFieldProps={{
        label: 'API Key',
        placeholder: 'Enter API Key',
      }}
      onDrawerClose={onDrawerClose}
    />
  );
};
